import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { MerchantUserService, StoreService } from 'app/services';
import moment from 'moment';
import { Utils } from 'app/utils';
import { MerchantUserRolesEnum, TypeMerchantUserEnum } from 'app/models';
import * as XLSX from 'xlsx';

enum EmployeeCreationFormatEnum {
    Individual = 1,
    Multiple = 2
}

enum MenuTabEnum {
    EmployeeDetail = 1,
    Role = 2,
    Location = 3,
    Email = 4
}

@Component({
    selector: 'create-merchant-employee',
    templateUrl: './create-merchant-employee.component.html',
    styleUrls: ['./create-merchant-employee.component.scss',
        '../../../../../../styles/sidebar.scss',
        '../../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class CreateMerchantEmployeeComponent implements OnInit, OnChanges {

    constructor(
        private messageService: MessageService,
        public storeService: StoreService,
        public merchantUserService: MerchantUserService
    ) { }
    ngOnChanges() {
        if (!this.isCreateEmployee) {
            this.showStepCreate = true;
            this.selectedCreationFormat = this.employeeCreationFormatEnum.Individual;
        } else {
            this.employee = {};
            this.showStepCreate = false;
            this.selectedCreationFormat = undefined;
        }

        this.menuItems[3].disabled = !this.isCreateEmployee;
    }
    ngOnInit() {
    }


    @Input()
    public visible!: boolean;
    @Input()
    public typeCreatedEmployee!: TypeMerchantUserEnum;
    @Input()
    public onHide: () => void = () => { };
    @Input()
    public merchantId!: any;
    @Input()
    public employee: any;
    @Input()
    public showEditFields!: boolean;
    @Input()
    public isCreateEmployee!: boolean;

    public menuTab = MenuTabEnum;
    public activeTab: MenuTabEnum = MenuTabEnum.EmployeeDetail;
    public menuItems: MenuItem[] = [
        {
            label: 'Employee Details',
            command: (e: any) => this.handleTabChange(MenuTabEnum.EmployeeDetail)
        },
        {
            label: 'Role',
            command: (e: any) => this.handleTabChange(MenuTabEnum.Role)
        },
        {
            label: 'Location',
            command: (e: any) => this.handleTabChange(MenuTabEnum.Location)
        },
        {
            label: 'Email',
            command: (e: any) => this.handleTabChange(MenuTabEnum.Email),
            disabled: false
        }
    ];

    public stores: any[] = [];
    public roleRights: any[] = [];
    public groupedRoleRights: any[] = [];
    public selectedSendMailDelay: any;
    public customSendMailDateTime: Date = new Date();

    public employeesXls: any[] = [];
    public showXlsUpload: boolean = false;
    public errorUploadedEmployees: any[] = [];
    public totalUploadedEmployeesCount: number = 0;
    public errorUploadedEmployeesCount: number = 0;
    public successUploadedEmployeesCount: number = 0;

    public sendMailDelay: any[] = [
        {
            id: 1,
            name: 'Now',
            delay: 0,
            showCustom: false
        },
        {
            id: 2,
            name: '24 hours',
            delay: 1440,
            showCustom: false
        },
        {
            id: 3,
            name: 'Custom',
            showCustom: true
        }
    ];

    public menuEditLocationItems: MenuItem[] = [
        {
            items: [
                {
                    label: 'Remove From Store',
                    command: () => {
                        this.removeFromStore();
                    }
                }
            ]
        }
    ];

    //Google maps autocomplete
    public addresses: any[] = [];

    public search(event: any) {
        const query = event.query;
        const service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions({ input: query }, (predictions, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                this.addresses = predictions ? predictions.map((prediction) => prediction.description) : [];
            } else {
                this.addresses = [];
            }
        });
    }

    public handleTabChange(menuTab: MenuTabEnum) {
        this.activeTab = menuTab;
        if (menuTab === this.menuTab.Location) {
            this.getMerchantLocations();
        }
        if (menuTab === this.menuTab.Role) {
            this.getUserRoleRights();
        }
    }

    public employeeCreationFormatEnum = EmployeeCreationFormatEnum;
    public selectedCreationFormat: EmployeeCreationFormatEnum | undefined = undefined;

    public storeRoles: any[] = [
        {
            id: MerchantUserRolesEnum.StoreManager,
            name: 'Store Manager'
        },
        {
            id: MerchantUserRolesEnum.Cashier,
            name: 'Cashier'
        },
        {
            id: MerchantUserRolesEnum.Dispatcher,
            name: 'Dispatcher'
        }
    ]
        ;
    public adminRoles: any[] = [
        //{
        //  id: MerchantUserRolesEnum.Administrator,
        //  name: 'Administrator'
        //},
        //{
        //  id: MerchantUserRolesEnum.Operations,
        //  name: 'Operations'
        //},
        //{
        //  id: MerchantUserRolesEnum.Marketing,
        //  name: 'Marketing'
        //},
        //{
        //  id: MerchantUserRolesEnum.Finance,
        //  name: 'Finance'
        //},
        {
            id: MerchantUserRolesEnum.Root,
            name: 'Root'
        }
    ];

    public typesMerchantEmployee = TypeMerchantUserEnum;
    public loading: boolean = false;
    public showStepCreate: boolean = false;

    public handleClose() {
        this.errorUploadedEmployees = [];
        this.visible = false;
        this.onHide();
        this.activeTab = this.menuTab.EmployeeDetail;
    }

    public handleChangeTypeCreatedEmployee(type: EmployeeCreationFormatEnum) {
        this.selectedCreationFormat = type;
    }

    //Upload image
    public handleInputClick(id: string): void {
        document.getElementById(id)?.click();
    }
    public handleImageChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }
        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.employee.ImageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    public getMerchantLocations() {
        const dto = {
            MerchantId: this.merchantId
        };

        this.storeService.getStoresByMerchant(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    //this.storesLoading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.stores = data.Items;

                this.employee.Store = this.employee.StoreId ? this.stores[this.stores.findIndex(store => store.Id === this.employee.StoreId)] : null;

                //  this.storesLoading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });

        this.storeService.getStoresByMerchant(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    //this.storesLoading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.stores = data.Items;

                this.employee.Store = this.employee.StoreId ? this.stores[this.stores.findIndex(store => store.Id === this.employee.StoreId)] : null;

                //  this.storesLoading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public addStoreToUser(event: any) {
        this.employee.Store = this.employee.StoreId ? this.stores[this.stores.findIndex(store => store.Id === this.employee.StoreId)] : null;
    }

    public removeFromStore() {
        this.employee.StoreId = undefined;
        this.employee.Store = undefined;
    }

    public uniqueGroupNames: any[] = [];
    public getUserRoleRights() {
        const dto = {
            IsAdmin: this.typeCreatedEmployee === TypeMerchantUserEnum.WebAdmins
        };

        this.merchantUserService.getUserRoleRights(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    //this.storesLoading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.roleRights = data.Items;
                //  this.storesLoading = false;
                this.uniqueGroupNames = [...new Set(data.Items.map((item: { GroupName: any }) => item.GroupName))];

                this.groupRoleRights();
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    //Roles
    public groupRoleRights() {
        const groups = this.roleRights.reduce((acc, curr) => {
            if (!acc[curr.GroupName]) {
                acc[curr.GroupName] = { GroupName: curr.GroupName, Actions: {} };
            }
            if (!acc[curr.GroupName].Actions[curr.DisplayName]) {
                acc[curr.GroupName].Actions[curr.DisplayName] = { DisplayName: curr.DisplayName, RoleIds: [] };
            }
            acc[curr.GroupName].Actions[curr.DisplayName].RoleIds.push(curr.RoleId);
            return acc;
        }, {});
        const result = Object.values(groups).map((group: any) => {
            group.Actions = Object.values(group.Actions);
            return group;
        });
        this.groupedRoleRights = result;
    }

    public hasPermission(action: any, roleId: number): boolean {
        return action.RoleIds.includes(roleId);
    }

    public createMerchantUser() {
        if (!this.checkFields()) {
            return;
        }
        const dto = this.getEmployeeDto();

        this.loading = true;
        this.merchantUserService.createMerchantUser(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Employee has been added' });
                this.handleClose();
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public updateMerchantUser() {
        if (!this.checkFields()) {
            return;
        }
        const dto = this.getEmployeeDto();

        this.loading = true;
        this.merchantUserService.updateMerchantUser(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Employee has been update' });
                this.handleClose();
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public checkFields(): boolean {
        if (!this.employee.Email) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Email not specified' });
            return false;
        }
        if (!this.checkEmail(this.employee.Email)) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Email is incorrect' });
            return false;
        }
        if (!this.employee.Phone) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Phone not specified' });
            return false;
        }
        if (!this.checkPhone(this.employee.Phone)) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid phone number' });
            return false;
        }
        if (!this.employee.FirstName) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'FirstName not specified' });
            return false;
        }
        if (!this.employee.LastName) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'LastName not specified' });
            return false;
        }
        if (!this.employee.Birthday) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Birthday not specified' });
            return false;
        }
        if (new Date(this.employee.Birthday) > new Date()) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Birthday cant be more today' });
            return false;
        }
        if (!this.employee.RoleId) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Role not specified' });
            return false;
        }
        if (!this.selectedSendMailDelay && this.isCreateEmployee) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Selected send mail delay not specified' });
            return false;
        }

        return true;
    }

    private getEmployeeDto() {
        return {
            UserId: this.employee.UserId,
            Email: this.employee.Email,
            Phone: this.employee.Phone,
            FirstName: this.employee.FirstName,
            LastName: this.employee.LastName,
            Address: this.employee.Address ?? '',
            Birthday: moment(this.employee.Birthday).format('YYYY-MM-DD'),
            RoleId: this.employee.RoleId,
            ExternalId: this.employee.ExternalId,
            DelayInMin: this.selectedSendMailDelay !== this.sendMailDelay[2] && this.selectedSendMailDelay ? this.selectedSendMailDelay.delay : -1,
            CustomSendEmailDateTime: this.selectedSendMailDelay === this.sendMailDelay[2] ?
                moment(this.customSendMailDateTime).format('YYYY-MM-DDTHH:mm:ss') : null,
            StoreId: this.employee.Store.Id,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            MerchantId: this.merchantId,
            ImageUrl: this.employee.ImageUrl
        };
    }

    private checkPhone(phone: string) {
        const phoneRegex = /^\+?\d{10,14}$/;
        return phoneRegex.test(phone);
    }

    private checkEmail(email: string) {
        const mailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        return mailRegex.test(email);
    }

    public handleXlsChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        this.merchantUserService.uploadEmployeesXls(formData, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.employeesXls = data.Items;
                this.handleUploadClick();
            });
    }

    public async handleUploadClick(): Promise<any> {
        this.loading = true;

        const dtos: any[] = [];

        // Check data and build dto for employees
        for (const employee of this.employeesXls) {
            const dto: any = {
                MerchantId: this.merchantId,
                FirstName: employee.FirstName,
                LastName: employee.LastName,
                Birthday: employee.Birthday,
                Email: employee.Email,
                Phone: employee.Phone,
                RoleId: employee.RoleId,
                StoreId: employee.RoleId,
                ExternalId: employee.RoleId,
                Address: employee.RoleId,
                DelayInMin: 10,
                TimeZoneOffset: Utils.getTimezoneOffset(),
                ImageUrl: employee.ImageUrl
            };

            dtos.push(dto);
        }

        let errorsCount = 0;

        // Create employees
        for (const dto of dtos) {
            const data = await this.merchantUserService.createMerchantUser(dto, this.messageService);

            if (data && !data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Warning', detail: data.ErrorMessage });
                errorsCount++;
                this.errorUploadedEmployees.push(dto);
            }
            else if (!data) {
                this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Request was not processed' });
                errorsCount++;
                this.errorUploadedEmployees.push(dto);
            }
        }

        this.loading = false;

        this.errorUploadedEmployeesCount = errorsCount;
        this.totalUploadedEmployeesCount = this.employeesXls.length;
        this.successUploadedEmployeesCount = this.totalUploadedEmployeesCount - this.errorUploadedEmployeesCount;

        this.showStepCreate = true;
    }

    public downloadTemplate() {
        const dto = {
            MerchantId: this.merchantId
        };
        this.merchantUserService.getMerchantUserTemplate(dto)
            .subscribe({
                next: (data) => {
                    const fileName = 'Employees Template';
                    const blob: Blob = data.body as Blob;

                    if (!data.ok) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        return;
                    }
                    const a = document.createElement('a');
                    a.download = fileName;
                    a.href = window.URL.createObjectURL(blob);
                    a.click();
                    a.remove();
                }, error: (err) => {
                    this.loading = false;
                    if (err.status === 500) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File not found' });
                    }
                    else {
                        throw err;
                    }
                }
            });
    }

    public saveUnuploadedEmployees() {
        const data = this.errorUploadedEmployees.map((item: any) => ({
            FirstName: item.FirstName,
            LastName: item.LastName,
            Address: item.Address,
            Birthday: item.Birthday,
            ExternalId: item.ExternalId,
            Phone: item.Phone,
            Email: item.Email,
            RoleId: item.RoleId,
            StoreId: item.StoreId,
            ImageUrl: item.ImageUrl,
        }));

        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, 'Unsuccessfully loaded products.xlsx');
    }
}
